/* unplugin-vue-components disabled */import script from "./EditorPanelOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorPanelOverlay.vue?vue&type=script&setup=true&lang=js"

import "./EditorPanelOverlay.vue?vue&type=style&index=0&id=aa60a12a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa60a12a"]])

export default __exports__